import React from 'react';
import PropTypes from 'prop-types';

// Renders a list of badges with a title. If a max length prop is provided,
// the list will not render more children than the specified value, and will
// give an indication of how many more items are not shown.
function BadgeList({ children, title, maxLength, style }) {
  const currentLength = children.length;
  let visibleChildren = children;
  if (maxLength) {
    visibleChildren = children.slice(0, maxLength);
  }

  return (
    <div className='badge-list' style={style}>
      {title && <span>{`${title}:`}</span>}
      {visibleChildren}
      {currentLength > maxLength && (
        <span className='help-block'>{`${currentLength - maxLength} more`}</span>
      )}
    </div>
  );
}

BadgeList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  title: PropTypes.string,
  maxLength: PropTypes.number,
  style: PropTypes.object,
};

// A badge component that has a clickable X icon if the removable prop is true.
// If clicked the onRemove prop will be called.
function Badge({ label, onRemove, removable = false }) {
  return (
    <span className='label label-info'>
      {label}
      {removable && (
        <span role='button' className='fa fa-times badge-close-button' onClick={onRemove} />
      )}
    </span>
  );
}

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  removable: PropTypes.bool,
  onRemove: PropTypes.func,
};

export { BadgeList, Badge };
